import { Pagination } from 'interfaces/common';
import {
	GET_LIST_SPECIALTIES, GET_SPECIALTIES_DETAIL, SpecialtiesActionTypes
} from './actionType';

interface SpecialtiesState {
  data: any;
  details: any;
  pagination: Pagination;
}

const initState: SpecialtiesState = {
  data: [],
  details: {},
  pagination: {
    count: 0,
    limit: 10,
    offset: 0,
    order: 'id',
    page: 1,
    total_page: 1,
    keyword: '',
    sort: 'desc',
    category: '',
    is_publish: 'true',
  }
};

const SpecialtiesReducer = (state = initState, action: SpecialtiesActionTypes) => {
  switch (action.type) {
		case GET_LIST_SPECIALTIES:
      return {
        ...state,
        data: action.data,
        pagination: action.pagination
      };
		case GET_SPECIALTIES_DETAIL:
      return {
        ...state,
        details: action.details
      };
    default:
      return state;
  }
};

export default SpecialtiesReducer;